import { useEffect, useLayoutEffect, useState } from "react";

export default function useOpenFilterModalWithLoader(
  initialOpen = true,
  canView = true
) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showInitialLoader, setShowInitialLoader] = useState(initialOpen);

  useLayoutEffect(() => {
    if (!canView || !initialOpen) {
      setShowFilterModal(false);
      setShowInitialLoader(false);
      return;
    }

    setShowInitialLoader(true);
    setShowFilterModal(false);

    const raf = window.requestAnimationFrame(() => {
      setShowFilterModal(true);
      setShowInitialLoader(false);
    });

    return () => window.cancelAnimationFrame(raf);
  }, [initialOpen, canView]);

  useEffect(() => {
    if (!canView) setShowFilterModal(false);
  }, [canView]);

  return { showFilterModal, setShowFilterModal, showInitialLoader };
}

